import { FC } from "react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { DataPoint, GraphTypeEnum } from "./types";
import { CustomXTick } from "./utility";

interface JobBarChartProps {
    dataPoints: DataPoint[];
    xAxisLabel?: string;
    yAxisLabel: string;
    chartType: GraphTypeEnum;
    errorMessage?: string;
}

export const JobBarChart: FC<React.PropsWithChildren<JobBarChartProps>> = (props: JobBarChartProps) => {
    if (props.errorMessage) {
      return (<p className="text-danger">{props.errorMessage}</p>);
    }
    if (props.dataPoints.length === 0) {
          return <p>This chart does not contain any data for the last 30 days.</p>;
    }
    return (
        <ResponsiveContainer width="100%" height={330}>
            <BarChart
                width={400}
                height={330}
                data={props.dataPoints}
                margin={{
                    bottom: 30,
                    left: 20,
                    right: 30,
                    top: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="xAxisValue" type="category" interval={props.chartType === GraphTypeEnum.Unknown ? 0 : "preserveEnd"} tick={<CustomXTick />} height={30} label={{ position: "insideBottom", value: props.xAxisLabel }} />
                <YAxis label={{ angle: -90, position: 'left', style: { "textAnchor": "middle" }, value: props.yAxisLabel }} />
                <Tooltip formatter={(value: string | number) => [value.toLocaleString(), props.yAxisLabel]} />
                {/* <Legend /> */}
                {/* Color should match sass variable $qes-primary-blue */}
                <Bar type="monotone" dataKey="yAxisValue" fill="#056edf" />
            </BarChart>
        </ResponsiveContainer>
    );
}
